import { render, staticRenderFns } from "./TreeMapWidget.vue?vue&type=template&id=c383687c&scoped=true&"
import script from "./TreeMapWidget.vue?vue&type=script&lang=js&"
export * from "./TreeMapWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c383687c",
  null
  
)

export default component.exports